import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { oneKlicks } from "../../../../SDK/oneclick";
import { getuserdata } from "../../../../services/apiService";




const BankAccountDetails = ({ userId }) => {

    const [bankAccountDetails, setBankAccountDetails] = useState({});

    useEffect(() => {
        getBankAccountDetails();
    }, [userId]);

    const getBankAccountDetails = async () => {
        try {
            const tableSchema = "";
            const tableName = "virtual_accounts";
            const conditions = {
                "user_id": userId || await getuserdata("id")
            };
            const orderBy = "id DESC";
            const search = null;
            const pagination = null;
            const margedata = null;
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getBankAccountDetails response :", response);
            if (response.success && response.data.length > 0) {
                const receiversData = response.data[0].receivers;
                // Check if receivers is a string and decode JSON
                console.log("receiversData :", receiversData);
                if (typeof receiversData === 'string') {
                    try {
                        console.log("receiversData parse :", receiversData);
                        const parsedReceivers = JSON.parse(receiversData);
                        setBankAccountDetails(parsedReceivers[0]);
                        console.log("receiversData parsedReceivers :", parsedReceivers);
                    } catch (error) {
                        console.error("Error parsing receivers JSON:", error);
                        setBankAccountDetails({});
                    }
                } else {
                    console.log("receiversData :", receiversData);
                    setBankAccountDetails(receiversData && receiversData.length > 0 ? receiversData[0] : {});
                }
            }
        } catch (error) {
            console.error("Error fetching invoice settings:", error);
        }
    };

    const handleChange = (field, value) => {
        setBankAccountDetails({ ...bankAccountDetails, [field]: value });
    };





    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-securityhold tab-pane active fade show" id="dc-security">
                <div className="dc-securitysettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Bank Account Details</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding">
                        {!bankAccountDetails.id ? (
                            <div className="dc-settingscontent dc-sidepadding">
                                <h6>No Bank Account Details Found</h6>
                            </div>
                        ) : (
                            <Form>
                                <h6>Bank Account Details</h6>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Bank Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Bank Name"
                                                readOnly
                                                value={bankAccountDetails.bank_name || ''}
                                                onChange={(e) => handleChange('bank_name', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Account Holder Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Account Holder Name"
                                                readOnly
                                                value={bankAccountDetails.name || ''}
                                                onChange={(e) => handleChange('name', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Ifsc Code</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Ifsc Code"
                                                readOnly
                                                value={bankAccountDetails.ifsc || ''}
                                                onChange={(e) => handleChange('ifsc', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Account Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Account Number"
                                                readOnly
                                                value={bankAccountDetails.account_number || ''}
                                                onChange={(e) => handleChange('account_number', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </Form>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default BankAccountDetails;
